/**
 * Browser session/visitor IDs for the web runtime.
 * Uses the same storage keys as @midpoint/client-view-sdk for cross-client consistency.
 */

const VISITOR_KEY = "midpoint_cv_visitor_id";
const SESSION_KEY = "midpoint_cv_session_id";

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `cv-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = randomId();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = randomId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
}

export function readUtmParams(searchParams) {
  const utm = {};
  ["source", "medium", "campaign", "term", "content"].forEach((key) => {
    const value = searchParams.get(`utm_${key}`);
    if (value) {
      utm[key] = value;
    }
  });
  return utm;
}

export function buildPageContext() {
  if (typeof window === "undefined") {
    return { url: null, path: null, title: null, referrer: null, utm: {} };
  }

  return {
    url: window.location.href,
    path: window.location.pathname,
    title: document.title || null,
    referrer: document.referrer || null,
    utm: readUtmParams(new URLSearchParams(window.location.search)),
  };
}
